<template lang="pug">
	header#header
		nav.linksUteis
			ul.redes
				li
					a(:href="$utils.redes.facebook", title="Facebook", target="_blank")
						include ../../assets/images/icones/icone-facebook.svg
				li
					a(:href="$utils.redes.instagram", title="Instagram", target="_blank")
						include ../../assets/images/icones/icone-instagram.svg
				li
					a(:href="$utils.redes.linkedin", title="Linkedin", target="_blank")
						include ../../assets/images/icones/icone-linkedin.svg
			ul.portais
				li.portalAluno
					a(href="https://aluno.unifael.edu.br/", target="_blank") Portal do Aluno
				li.portalColaborador
					a(href="https://intranet.fael.edu.br/", target="_blank") Área Administrativa

		nav.menu
			.wrapper
				div.logo
					router-link(:to="{ name:'home' }")
						h1(@click="fecharMenu()")
							| Centro Universitário UNIFAEL
							//- include ../../assets/images/icones/icone-fael.svg
							img(:src="require(`@images/icones/logo-header.png`)")
				div.nav(:class="{'ativo': menuAtivo}")
					ul.redes
						li
							a(:href="$utils.redes.facebook", title="Facebook", target="_blank")
								include ../../assets/images/icones/icone-facebook.svg
						li
							a(:href="$utils.redes.instagram", title="Instagram", target="_blank")
								include ../../assets/images/icones/icone-instagram.svg
						li
							a(:href="$utils.redes.linkedin", title="Linkedin", target="_blank")
								include ../../assets/images/icones/icone-linkedin.svg
					ul.principal
						li(@click="fecharMenu()")
							router-link(:to="{name:'cursos', params: {tipo: 'graduacao'}}") Graduação EAD
						li(@click="fecharMenu()")
							router-link(:to="{name:'cursos', params: {tipo: 'graduacao-presencial'}}") Graduação Presencial
						li(@click="fecharMenu()")
							router-link(:to="{name:'cursos', params: {tipo: 'pos-graduacao'}}") Pós-Graduação
						//- li(@click="fecharMenu()")
							router-link(:to="{name:'cursos', params: {tipo: 'tecnico'}}") Técnico
						//- li(@click="fecharMenu()")
							a(href="https://faelflix.com.br", target="_blank") FAELFLIX
						//- li(@click="fecharMenu()")
							a(href="/extensao-universitaria") Extensão
					ul.secundaria
						li(@click="fecharMenu()")
							a(href="https://expansao.sereducacional.com/", target="_blank") Seja um Polo
						//- li(@click="fecharMenu()")
							router-link(:to="{name:'bolsas-e-descontos'}") Bolsas e Descontos
						//- li(@click="fecharMenu()")
						//- 	a(href="https://conheca.fael.edu.br/ingresso", target="_blank") Transferência e Aproveitamento
							//- router-link(:to="{name:'transferencia-e-aproveitamento'}") Transferência e Aproveitamento
						li(@click="fecharMenu()")
							router-link(:to="{name:'unidades'}") Unidades UNIFAEL
						li(@click="fecharMenu()")
							a(href="#contato", @click.prevent="contatoAtivo = !contatoAtivo") Contato
				button.buttonMenu(@click="toggleMenu()" :class="{'ativo': menuAtivo}")
					i.up
					i.down

		AsideFaleComAFael(:ativo.sync="contatoAtivo")
</template>

<script>
	import AsideFaleComAFael from '@components/AsideFaleComAFael/AsideFaleComAFael.vue'

	export default {
		name: "component-header",
		components: {
			AsideFaleComAFael
		},
		data() {
			return {
				menuAtivo: false,
				contatoAtivo: false
			}
		},
		methods: {
			toggleMenu() {
				this.menuAtivo = !this.menuAtivo
			},
			fecharMenu() {
				this.menuAtivo = false
			},
		},
	}
</script>

<style lang="stylus" scoped src="./Header.styl"></style>
